import { Extension } from '@tiptap/core';
function linkAttributesToString(attrs) {
  return Object.entries(attrs).map(([key, value]) => `${key}="${value}"`).join(' ');
}
const TuiFileLink = Extension.create({
  name: 'fileLink',
  addCommands() {
    return {
      setFileLink: fileLink => ({
        state,
        chain
      }) => {
        const {
          selection
        } = state;
        const selectedSize = Math.abs(selection.to - selection.from);
        const whitespace = '<span style="font-size: 15px"> </span>';
        const attrs = fileLink.attrs ? linkAttributesToString(fileLink.attrs) : '';
        return (selectedSize > 0 ? chain().toggleMark('link', {
          href: fileLink.link
        }, {
          extendEmptyMarkRange: true
        }).setTextSelection(selection.to).insertContent(whitespace) : chain().insertContent(`<a href="${fileLink.link}" ${attrs}>${fileLink.name}</a>${whitespace}`)).setTextSelection(selection.to).run();
      }
    };
  }
});

/**
 * Generated bundle index. Do not edit.
 */

export { TuiFileLink };
